import { PlaybookType } from './playbooks';
import getPlaybookAgentsFromTypes from './getPlaybookAgentsFromTypes';
import { getWorkflowTitle } from '../copy/productCopy';

function buildPlaybookData(playbookConfig) {
  return {
    key: playbookConfig.value,
    title: getWorkflowTitle(playbookConfig.title),
    shortDescription: playbookConfig.shortDescription,
    icon: playbookConfig.icon,
    agentTypes: playbookConfig.agentTypes,
    agentDescriptions: playbookConfig.agentDescriptions ?? {},
    agents: getPlaybookAgentsFromTypes(playbookConfig.agentTypes || [], playbookConfig),
  };
}

const allPlaybookConfigs = Object.values(PlaybookType);
export const allPlaybooksData = allPlaybookConfigs.map(config => buildPlaybookData(config));

export function getActiveAndAvailablePlaybooks(subscribedPlaybooks) {
  const playbookDataByKey = allPlaybooksData.reduce((acc, p) => ({ ...acc, [p.key]: p }), {});

  const subscribedKeys = new Set();
  const activePlaybooksData = (subscribedPlaybooks || [])
    .map(pb => {
      const key = typeof pb === 'object' && pb?.value ? pb.value : pb;
      subscribedKeys.add(key);
      const localPlaybook = playbookDataByKey[key];
      if (!localPlaybook) return null;

      if (typeof pb === 'object') {
        return {
          ...localPlaybook,
          id: pb.id || '',
          value: pb.value || key,
          playbookType: pb.playbookType || pb.value || key,
          isDefault: Boolean(pb.isDefault),
          serverTitle: pb.title || '',
          // If backend sends agentTypes, prefer them to avoid drift.
          agentTypes: Array.isArray(pb.agentTypes) ? pb.agentTypes : localPlaybook.agentTypes,
        };
      }

      return localPlaybook;
    })
    .filter(Boolean);

  const availablePlaybooksData = allPlaybooksData.filter(p => !subscribedKeys.has(p.key));

  return {
    activePlaybooksData,
    availablePlaybooksData,
    playbookDataByKey,
  };
}

export const playbookDataByKey = allPlaybooksData.reduce((acc, p) => ({ ...acc, [p.key]: p }), {});
